import getChartData from '@/api/chart'
import { DASHBOARD_CHART_DEFINITION, COVERAGE_CHART_DEFINITION, CHART_DEFINITION } from '@/misc/desktopCharts'

const state = {
  chartData: {},
  currentPage: '',
  dashBoardSelectedDate: null,
  coverageSelectedDate: null
}

const getters = {
  currentCharts: state => state.chartData,
  currentPage: state => state.currentPage,
  dashBoardSelectedDate: state => state.dashBoardSelectedDate,
  coverageSelectedDate: state => state.coverageSelectedDate
}

const actions = {
  async fetchCurrentChartData ({ commit, getters, rootGetters }, chartName) {
    const chartPage = getters.currentPage
    const targetDate = chartPage === 'dashboard' ? getters.dashBoardSelectedDate : getters.coverageSelectedDate
    const currentStore = rootGetters['user/getCurrentStore']
    commit('setLoading', chartName)
    try {
      let chartData = await getChartData(chartName, targetDate, currentStore.store_id)
      commit('setChartData', { chartName, chartData, targetDate })
    } catch (e) {
      commit('setChartError', chartName)
    }
  },
  setCurrentChartData ({ dispatch, getters }) {
    if (getters.currentPage === 'dashboard') {
      if (!getters.dashBoardSelectedDate) return

      DASHBOARD_CHART_DEFINITION.forEach(chart => {
        dispatch('fetchCurrentChartData', chart.name)
      })
    } else if (getters.currentPage === 'coverage') {
      if (!getters.coverageSelectedDate) return

      COVERAGE_CHART_DEFINITION.forEach(chart => {
        dispatch('fetchCurrentChartData', chart.name)
      })
      dispatch('itemCoverage/setCurrentItemCoverageData', null, { root: true })
    }
  },
  resetGroupOfCharts ({ commit, dispatch, getters }) {
    if (getters.currentPage === 'dashboard') {
      DASHBOARD_CHART_DEFINITION.forEach(chart => {
        commit('resetChartData', chart.name)
      })
    } else if (getters.currentPage === 'coverage') {
      COVERAGE_CHART_DEFINITION.forEach(chart => {
        commit('resetChartData', chart.name)
      })
    }
    dispatch('setCurrentChartData')
  },
  resetAllCharts ({ commit, dispatch }) {
    CHART_DEFINITION.forEach(chart => {
      commit('resetChartData', chart.name)
    })
    dispatch('setCurrentChartData')
  },
  setDashboardDate ({ dispatch, commit }, date) {
    commit('setSelectedDashboardDate', date)
    dispatch('setCurrentChartData')
  },
  setCoverageDate ({ dispatch, commit }, date) {
    commit('setSelectedCoverageDate', date)
    dispatch('setCurrentChartData')
  },
  setCurrentPage ({ commit, dispatch }, page) {
    commit('setPage', page)
    dispatch('resetGroupOfCharts')
  }
}

const mutations = {
  setPage (state, currentPage) {
    state.currentPage = currentPage
  },
  resetChartData (state, chartName) {
    state.chartData[chartName] = {}
  },
  setLoading (state, chartName) {
    state.chartData = {
      ...state.chartData,
      [chartName]: { isLoading: true }
    }
  },
  setChartError (state, chartName) {
    state.chartData = {
      ...state.chartData,
      [chartName]: { isError: true }
    }
  },
  setChartData (state, payload) {
    let { chartName, chartData, targetDate } = payload
    state.chartData = {
      ...state.chartData,
      [chartName]: {
        dates: targetDate,
        ...chartData
      }
    }
  },
  setSelectedDashboardDate (state, date) {
    state.dashBoardSelectedDate = date
  },
  setSelectedCoverageDate (state, date) {
    state.coverageSelectedDate = date
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
